export const FONTS = ['Arial', 'Roboto', 'Open Sans', 'Montserrat', 'Playfair Display', 'Oswald'];
